import {
    HeadSectionContent,
    SectionsTitleText,
} from "../../models/common/common";
import { FilterResponseTO, SearchCard } from "../../models/search";
import colors from "../../styles/colors.module.scss";

/* eslint-disable */
//mi segnala la necessità di create template per via di strutture di dato ridondanti
//tuttavia al fine dei dati mock irrilevante
export const newFiltersMockData: FilterResponseTO = {
    tourTypes: ["Across Italy", "Into the Region", "Down the City"],
    destinations: [
        "Rome",
        "Sorrento",
        "Venice",
        "Florence",
        "Amalfi",
        "Napoli",
        "Bologna",
        "Milan & Como",
        "Puglia",
        "Sardinia",
        "Pompeii",
        "Benevento",
    ],
    minPrice: "500",
    maxPrice: "5000",
    activities: [
        "Adventurous",
        "City Sightseeing",
        "Food & Wine",
        "Free Time",
        "History & Arts",
        "Relaxing",
        "Seaside & Boat Activities",
    ],
};

export const packageMockData: SearchCard[] = [
    {
        id: "640f2cf7f85e0e590ea216e3",
        type: "Across Italy",
        title: "Rome, Florence and Tuscany 6 days/5 nights Rome – Florence",
        rating: 0,
        mainPlace: "Colosseum",
        reviews: 0,
        quality: {
            description:
                "Combine the 'Eternal City' of Rome with the Renaissance charms of Florence and the beauty of Tuscany countryside! Spend a few days visiting Rome and go back in time discovering the Colosseum, one of the 7 wonders of the World, and the unique masterpieces of the Vatican Museums with a professional guide. Then, catch your train to Florence, the Cradle of Renaissance. Admire the most famous art pieces of the Uffizi Gallery and the Accademia Gallery while admiring the unique treasures of Florence Cathedral. You will complete your experience with a delightful day trip in the most spellbinding sights in Tuscany: Siena, San Gimignano and Pisa. ",
            destinations: ["Firenze", "Roma", "San Gimignano", "Pisa", "Siena"],
            regions: ["Lazio", "Tuscany"],
            image: "https://d1s9epp90f3vor.cloudfront.net/tours/Rome-Florence-Tuscany.webp",
            days: 6,
            nights: 5,
            price: 2329.0,
            activities: ["Food", "Explore"],
        },
        premium: {
            description:
                "Combine the 'Eternal City' of Rome with the Renaissance charms of Florence and the beauty of Tuscany countryside! Spend a few days visiting Rome and go back in time discovering the Colosseum, one of the 7 wonders of the World, and the unique masterpieces of the Vatican Museums with a professional guide. Then, catch your train to Florence, the Cradle of Renaissance. Admire the most famous art pieces of the Uffizi Gallery and the Accademia Gallery while admiring the unique treasures of Florence Cathedral. You will complete your experience with a delightful day trip in the most spellbinding sights in Tuscany: Siena, San Gimignano and Pisa. ",
            destinations: [
                "Firenze",
                "Roma",
                "San Gimignano",
                "Pisa",
                "Monteriggioni",
            ],
            regions: ["Lazio", "Tuscany"],
            image: "https://d1s9epp90f3vor.cloudfront.net/tours/Rome-Florence-Tuscany.webp",
            days: 6,
            nights: 5,
            price: 2329.0,
            activities: ["Explore", "Wine Tasting"],
        },
    },
    {
        id: "640f15639604cb389ceda5ff",
        type: "Into the Region",
        title: "Best of Florence",
        rating: 0,
        mainPlace: "Piazza San Marco",
        reviews: 0,
        quality: {
            description:
                "Get a chance to discover the most fascinating and interesting sites of Florence in just a few days. First, we will start with a comprehensive guided visit of the Accademia Gallery and of the most important sites of the city, then we’ll immerse yourself in the Renaissance art and history of the Uffizi Gallery with the masterpieces of Botticelli, Michelangelo, Leonardo da Vinci, Raffaello, Giotto, and many others.",
            destinations: ["Firenze"],
            regions: ["Tuscany"],
            image: "https://d1s9epp90f3vor.cloudfront.net/tours/Best-of-Florence.webp",
            days: 3,
            nights: 2,
            price: 765.0,
            activities: ["Flight"],
        },
        premium: {
            description:
                "Rome and the best of the Amalfi Coast finally within your grasp. This six-day tour is an unforgettable journey around Italy’s central and southern coastline overlooking the Tyrrhenian Sea. Guided tours in Rome will show you more than just the highlights. From Rome, reach Sorrento and feast your eyes with the beautiful architecture of the coastline villages. You will mingle with the locals in Ravello, Positano and the glittering Capri. On your last day, the amazing Pompeii ruins will be like the cherry on a cake!",
            destinations: ["Firenze"],
            regions: ["Tuscany"],
            image: "https://d1s9epp90f3vor.cloudfront.net/tours/Best-of-Florence.webp",
            days: 3,
            nights: 2,
            price: 765.0,
            activities: ["Flight"],
        },
    },
    {
        id: "640f76207d1e3531866ad5bd",
        type: "Across Italy",
        title: "Rome, Sorrento and the Amalfi Coast 6 days/5 nights Rome – Sorrento – Rome",
        rating: 0,
        mainPlace: "Piazza San Marco",
        reviews: 0,
        quality: {
            description:
                "Rome and the best of the Amalfi Coast finally within your grasp. This six-day tour is an unforgettable journey around Italy’s central and southern coastline overlooking the Tyrrhenian Sea. Guided tours in Rome will show you more than just the highlights. From Rome, reach Sorrento and feast your eyes with the beautiful architecture of the coastline villages. You will mingle with the locals in Ravello, Positano and the glittering Capri. On your last day, the amazing Pompeii ruins will be like the cherry on a cake!",
            destinations: [
                "Sorrento",
                "Capri",
                "Amalfi",
                "Positano",
                "Ravello",
                "Pompei",
                "Roma",
            ],
            regions: ["Lazio", "Campania"],
            image: "https://d1s9epp90f3vor.cloudfront.net/tours/Rome-Sorrento-Amalfi.webp",
            days: 6,
            nights: 5,
            price: 4425.0,
            activities: ["Walking", "Explore"],
        },
        premium: {
            description:
                "Rome and the best of the Amalfi Coast finally within your grasp. This six-day tour is an unforgettable journey around Italy’s central and southern coastline overlooking the Tyrrhenian Sea. Guided tours in Rome will show you more than just the highlights. From Rome, reach Sorrento and feast your eyes with the beautiful architecture of the coastline villages. You will mingle with the locals in Ravello, Positano and the glittering Capri. On your last day, the amazing Pompeii ruins will be like the cherry on a cake!",
            destinations: [
                "Sorrento",
                "Capri",
                "Amalfi",
                "Positano",
                "Ravello",
                "Pompei",
                "Roma",
            ],
            regions: ["Lazio", "Campania"],
            image: "https://d1s9epp90f3vor.cloudfront.net/tours/Rome-Sorrento-Amalfi.webp",
            days: 6,
            nights: 5,
            price: 4425.0,
            activities: ["Food", "Train"],
        },
    },
    {
        id: "641c77c0792306719b04f48e",
        type: "Into the Region",
        title: "The Best of Sorrento & The Amalfi Coast",
        rating: 0,
        mainPlace: "Colosseum",
        reviews: 0,
        quality: {
            description:
                "Explore Sorrento and its surroundings like a true insider! Join a private comfortable ride to and from your accommodation solely reserved for your party! Visit the town with a dedicated official guide tasting the local flavors, off the beaten tracks. Get to visit the unmatchable Amalfi Coast exploring Positano, Amalfi and Ravello by joining a boat tour of the coast that offers a unique panorama of the Gulf.  Don’t miss the fascinating island of Capri:you’ll explore it on board a typical Gozzo Sorrentino sailing on the blue water of the Mediterranean sea.  Enjoy a leisure day in Sorrento having lunch by the sea,sunbathing and swimming at a wonderful beach club. Visit the worldly famous archaeological site of Pompeii, a living picture of the 79 A.D.  Enjoy a delicious dinner in Sorrento at a typical restaurant in a fairy-like garden in the heart of the city.",
            destinations: [
                "Naples",
                "Sorrento",
                "Capri",
                "Amalfi",
                "Positano",
                "Ravello",
                "Pompei",
            ],
            regions: ["Campania"],

            image: "https://d1s9epp90f3vor.cloudfront.net/tours/The-Best-of-Sorrento-The-Amalfi.webp",
            days: 7,
            nights: 6,
            price: 4627.0,
            activities: ["Food", "Explore"],
        },
        premium: {
            description:
                "Explore Sorrento and its surroundings like a true insider! Join a private comfortable ride to and from your accommodation solely reserved for your party! Visit the town with a dedicated official guide tasting the local flavors, off the beaten tracks. Get to visit the unmatchable Amalfi Coast exploring Positano, Amalfi and Ravello suspended on the green water of the Gulf. Don’t miss the fascinating island of Capri,you’ll explore it on board of a typical Gozzo Sorrentino sailing on the blue water of the Mediterranean sea.  Enjoy a day at leisure in Sorrento having lunch on the sea and sunbathing, swimming at a wonderful beach club. Visit the worldly famous archaeological site of Pompeii with an official dedicated guide and enjoy a wine tasting with a typical lunch on the slopes of the Volcano Vesuvius.  Dinner will be held  in Sorrento in a unique restaurant on the beach located in the fishing village of Marina Grande.",
            destinations: [
                "Naples",
                "Sorrento",
                "Capri",
                "Amalfi",
                "Positano",
                "Ravello",
                "Pompei",
            ],
            regions: ["Campania"],

            image: "https://d1s9epp90f3vor.cloudfront.net/tours/The-Best-of-Sorrento-The-Amalfi.webp",
            days: 8,
            nights: 7,
            price: 4627.0,
            activities: ["Explore", "Wine Tasting"],
        },
    },
    {
        id: "640f5b512f1c05383ffbe2b9",
        type: "Down the City",
        title: "Taste of Tuscany: food and wine trails between stunning landscapes and dream villages 4 days / 3 nights",
        rating: 0,
        mainPlace: "Chiostro di San Francesco",
        reviews: 0,
        quality: {
            description:
                "Live an unforgettable experience in the name of authentic Food & Wine of this wonderful region. Visit Greve and Castellina in Chianti, Montalcino and Montepulciano, be amazed by the panorama of the green Val d'Orcia and taste fine wines, extra virgin olive oil and genuine farms products. On the following day, complete your experience with an exclusive cooking class in an ancient Castle in the Tuscan countryside and visit the medieval San Gimignano.",
            destinations: [
                "Firenze",
                "San Gimignano",
                "Radda in Chianti",
                "Val d’Orcia",
                "Monteriggioni",
            ],
            regions: ["Tuscany"],

            image: "https://d1s9epp90f3vor.cloudfront.net/tours/Taste-of-Tuscany.webp",
            days: 4,
            nights: 3,
            price: 3000.0,
            activities: ["Train"],
        },
        premium: {
            description:
                "Live an unforgettable experience in the name of authentic Food & Wine of this wonderful region. Visit Greve and Castellina in Chianti, Montalcino and Montepulciano, be amazed by the panorama of the green Val d'Orcia and taste fine wines, extra virgin olive oil and genuine farms products. On the following day, complete your experience with an exclusive cooking class in an ancient Castle in the Tuscan countryside and visit the medieval San Gimignano.",
            destinations: [
                "Firenze",
                "San Gimignano",
                "Radda in Chianti",
                "Val d’Orcia",
            ],
            regions: ["Tuscany"],
            image: "https://d1s9epp90f3vor.cloudfront.net/tours/Taste-of-Tuscany.webp",
            days: 4,
            nights: 3,
            price: 3000.0,
            activities: ["Food", "Wine Tasting"],
        },
    },
    {
        id: "640f4f13eb4b22063254d3e7",
        type: "Down the City",
        title: "Florence great Art & Crafts 4 days / 3 nights",
        rating: 0,
        mainPlace: "Basilica di Santa croce",
        reviews: 0,
        quality: {
            description:
                "A city break that will make you discover not only the art, history and traditions of Florence but also its high quality arts and crafts unique in the world. Your guide will take you on a thrilling walking tour through one of the most picturesque and cool districts of Florence, the “Oltrarno”:  you will visit the local artisans, Workshops and the charming Santo Spirito Church, which contains among its treasures a wonderful wooden sculpture of MIchelangelo. On the following day, you will explore with your guide the treasures of Santa Croce Basilica, its wonderful Cloister and the rooms of the ancient convent where you will admire the skilled artisans keep alive centennial working techniques of an historical leather shop.",
            destinations: ["Firenze"],
            regions: ["Tuscany"],
            image: "https://d1s9epp90f3vor.cloudfront.net/tours/Florence-great-Art-Crafts.webp",
            days: 4,
            nights: 3,
            price: 4850.0,
            activities: ["Explore"],
        },
        premium: {
            description:
                "A city break that will make you discover not only the art, history and traditions of Florence but also its high quality arts and crafts unique in the world. Your guide will take you on a thrilling walking tour through one of the most picturesque and cool districts of Florence, the “Oltrarno”:  you will visit the local artisans, Workshops and the charming Santo Spirito Church, which contains among its treasures a wonderful wooden sculpture of MIchelangelo. On the following day, you will explore with your guide the treasures of Santa Croce Basilica, its wonderful Cloister and the rooms of the ancient convent where you will admire the skilled artisans keep alive centennial working techniques of an historical leather shop.",
            destinations: ["Firenze"],
            regions: ["Tuscany"],
            image: "https://d1s9epp90f3vor.cloudfront.net/tours/Florence-great-Art-Crafts.webp",
            days: 4,
            nights: 3,
            price: 4850.0,
            activities: ["Explore", "Shop in the city"],
        },
    },
];

const headTitle: SectionsTitleText[] = [
    {
        text: "Our",
        color: colors.textWhiteLight,
        fontWeight: "fw-bold",
        newLine: false,
    },
    {
        text: "tours,",
        color: colors.textPrimary,
        fontWeight: "fw-bold",
        newLine: true,
    },
    {
        text: "your Italian",
        color: colors.textWhiteLight,
        fontWeight: "fw-bold",
        newLine: false,
    },
    {
        text: "experience",
        color: colors.textPrimary,
        fontWeight: "fw-bold",
        newLine: false,
    },
];

const headSubTitle: SectionsTitleText[] = [
    {
        text: "",
        color: colors.textWhiteLight,
        fontWeight: "fw-bold",
        newLine: false,
    },
];

export const headData: HeadSectionContent = {
    backgroundImageUrl: "/images/search-head.webp",
    title: headTitle,
    subTitle: headSubTitle,
};
